import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_4 = ["colspan"]
const _hoisted_5 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "task-details"
}
const _hoisted_10 = { class: "container row m-0 p-1" }
const _hoisted_11 = { class: "form-group col-6 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "repeat" }, " Repeat ", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group col-6 mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, " Date ", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "fw-normal ms-1"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "(Current Benefit Period: ", -1 /* HOISTED */)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "-", -1 /* HOISTED */)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "input-group date datepickerInput" }
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-control",
  placeholder: "MM/DD/YYYY"
}, null, -1 /* HOISTED */)
const _hoisted_30 = { class: "form-group col-6 mt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Task ", -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_33 = { class: "form-group col-6 mt-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "employee" }, " Employee ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group col-4 mt-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "payer" }, " Payer ", -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Payer", -1 /* HOISTED */)
const _hoisted_39 = ["label"]
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "form-group col-4 mt-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "shift-length" }, " Shift Length ", -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select Shift Length", -1 /* HOISTED */)
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "form-group col-4 mt-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "shift-time" }, " Shift Start Time ", -1 /* HOISTED */)
const _hoisted_47 = ["value", "disabled"]
const _hoisted_48 = { class: "form-group form-check custom-checkbox col-2 mt-2 ms-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "on-call-visit"
}, " On-Call Visit ", -1 /* HOISTED */)
const _hoisted_50 = {
  key: 0,
  class: "col-10 offset-md-1 row g-0 justify-content-center"
}
const _hoisted_51 = { class: "col-5 pe-2 ms-2" }
const _hoisted_52 = {
  key: 2,
  class: "d-flex justify-content-center my-2"
}
const _hoisted_53 = ["colspan"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center text-warning fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }),
  /*#__PURE__*/_createElementVNode("span", null, " Warning: The task you are attempting to schedule is outside of the ordered visit frequency. ")
], -1 /* HOISTED */)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center text-warning fw-bold" }, "Do you want to continue scheduling?", -1 /* HOISTED */)
const _hoisted_56 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_MultiDatePicker = _resolveComponent("MultiDatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_FrequencyCheck = _resolveComponent("FrequencyCheck")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.statusItem.Branch
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.statusItem.Team
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePatientNameClick(_ctx.statusItem)))
        }, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.statusItem.PatientFirstName
          }, null, 8 /* PROPS */, ["text"])
        ])
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePatientNameClick(_ctx.statusItem)))
        }, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.statusItem.PatientLastName
          }, null, 8 /* PROPS */, ["text"])
        ])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.statusItem.Mrn
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.getStatusName }, null, 8 /* PROPS */, ["text"])
      ]),
      (_ctx.statusItem.Task)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.statusItem.Task
            }, null, 8 /* PROPS */, ["text"])
          ]))
        : (_openBlock(), _createElementBlock("td", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addTask(_ctx.statusItem.PatientId)))
            }, "Add Task")
          ])),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.statusItem.TaskType
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.getTaskStatusName }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.statusItem.VisitDate)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.formatDate(_ctx.statusItem.AdmissionDate)
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.getDaysRemaining,
          exceptionMessage: "Not Applicable"
        }, null, 8 /* PROPS */, ["text"])
      ])
    ], 2 /* CLASS */),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
          (!_ctx.isFrequencyWarningRequested)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                colspan: _ctx.columns,
                class: "p-3"
              }, [
                _createVNode(_component_FormSection, {
                  "full-height": false,
                  title: "Employee Scheduler",
                  "application-id": _ctx.application,
                  "show-product-pill": true
                }, {
                  content: _withCtx(() => [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_5, _hoisted_8))
                      : (_openBlock(), _createElementBlock("section", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _hoisted_12,
                              _withDirectives(_createElementVNode("select", {
                                id: "repeat",
                                class: "form-select",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTaskRepeat) = $event))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.tasks), ([key, value]) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: key,
                                    value: value.value
                                  }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_13))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.newTaskRepeat]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _hoisted_16,
                              (_ctx.patient)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_17, [
                                    (
                                            (_ctx.patient.benefitPeriodStartDate ||
                                                _ctx.patient.transferBenefitPeriodStartDate) &&
                                            _ctx.patient.benefitPeriodEndDate
                                        )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                          _hoisted_19,
                                          (_ctx.patient.isTransfer)
                                            ? (_openBlock(), _createElementBlock("strong", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.patient.transferBenefitPeriodStartDate)), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.patient.benefitPeriodStartDate)), 1 /* TEXT */)),
                                          _hoisted_22,
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.patient.benefitPeriodEndDate)) + ")", 1 /* TEXT */)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                          (_ctx.isPatientPending)
                                            ? (_openBlock(), _createElementBlock("strong", _hoisted_24, "(Current Benefit Period: Pending)"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_25, " No Benefit Period Found "))
                                        ]))
                                  ])), [
                                    [_directive_tooltip, { title: `Current Benefit Period` }]
                                  ])
                                : _createCommentVNode("v-if", true),
                              (_ctx.newTaskRepeat == 0)
                                ? (_openBlock(), _createBlock(_component_DatePicker, {
                                    key: 1,
                                    getDate: _ctx.changeNewTaskSingleDate
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("input", {
                                          name: "newTaskSingleDate",
                                          type: "text",
                                          class: "form-control",
                                          placeholder: "MM/DD/YYYY",
                                          value: _ctx.formatDateInput(_ctx.newTaskSingleDate)
                                        }, null, 8 /* PROPS */, _hoisted_27),
                                        _hoisted_28
                                      ])
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["getDate"]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.newTaskRepeat == 1 || _ctx.newTaskRepeat == 2 || _ctx.newTaskRepeat == 4)
                                ? (_openBlock(), _createBlock(_component_DateRangePicker, {
                                    key: 2,
                                    options: _ctx.newTaskRangePickerOptions
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "MM/DD/YYYY",
                                        name: "daterange",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newTaskDateRange) = $event)),
                                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setNewTaskDateRange && _ctx.setNewTaskDateRange(...args)))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelText, _ctx.newTaskDateRange]
                                      ])
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["options"]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.newTaskRepeat == 3)
                                ? (_openBlock(), _createBlock(_component_MultiDatePicker, {
                                    key: 3,
                                    result: _ctx.newTaskFlexDates,
                                    onUpdateResult: _ctx.updatenewTaskFlexDates
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_29
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["result", "onUpdateResult"]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _hoisted_32,
                              _createVNode(_component_TypeaheadInput, {
                                getData: _ctx.availableTasksFilter,
                                value: _ctx.taskList,
                                onValueChanged: _ctx.changeTaskList,
                                placeholder: "Type to Filter Task",
                                disabled: !_ctx.isDateSelected,
                                "show-all-by-default": true,
                                "open-on-focus": true,
                                "must-select-value": true,
                                ref: "typeAheadRefTask"
                              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createVNode(_component_TypeaheadInput, {
                                getData: _ctx.employeeListFilter,
                                value: _ctx.scheduleEmployeeId,
                                onValueChanged: _ctx.changeScheduleEmployeeId,
                                placeholder: "Type to Search Employee",
                                "show-all-by-default": true,
                                disabled: !_ctx.isDateSelected || !_ctx.isTaskSelected,
                                ref: "typeAheadRefEmp"
                              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _hoisted_37,
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                name: "payer",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newTask.patientPayerId) = $event))
                              }, [
                                _hoisted_38,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payerTypes, (payer) => {
                                  return (_openBlock(), _createElementBlock("optgroup", {
                                    key: payer.name,
                                    label: payer.name
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientPayers, (type) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: type.id,
                                        key: type.id
                                      }, [
                                        (type.payerType === payer.value)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(type.name), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_40))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 8 /* PROPS */, _hoisted_39))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.newTask.patientPayerId]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.shiftLength) = $event))
                              }, [
                                _hoisted_43,
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                  return _createElementVNode("option", {
                                    key: i,
                                    value: i
                                  }, _toDisplayString(i) + " " + _toDisplayString(i === 1 ? "Hour" : "Hours"), 9 /* TEXT, PROPS */, _hoisted_44)
                                }), 64 /* STABLE_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.shiftLength]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeStartTime }, {
                                default: _withCtx(() => [
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    value: _ctx.shiftStartTime,
                                    autocomplete: "off",
                                    maxlength: "8",
                                    disabled: _ctx.shiftLength <= 0,
                                    placeholder: "Enter Shift Start Time"
                                  }, null, 8 /* PROPS */, _hoisted_47)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["onUpdateProps"])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "on-call-visit",
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newTask.onCall) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.newTask.onCall]
                              ]),
                              _hoisted_49
                            ])
                          ]),
                          (_ctx.taskListItems && _ctx.taskListItems.id)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createVNode(_component_FrequencyCheck, {
                                    "visit-details": _ctx.getVisitDetails,
                                    "visit-dates": _ctx.newTaskStartDates,
                                    onUpdateVisitDates: _ctx.updateVisitDates,
                                    "selected-task": _ctx.taskListItems,
                                    "is-outside-frequency": _ctx.isOutsideFrequency,
                                    onUpdateOutsideFrequency: _ctx.updateOutsideFrequency
                                  }, null, 8 /* PROPS */, ["visit-details", "visit-dates", "onUpdateVisitDates", "selected-task", "is-outside-frequency", "onUpdateOutsideFrequency"])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])),
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          (!_ctx.isOutsideFrequency)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-md me-2",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.createTask('1')))
                                }, " Save Task "),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-md",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveAndAddAnother('2')))
                                }, " Save Task and Add Another ")
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-md me-2",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showFrequencyWarning(false)))
                                }, " Save Task "),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-md",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showFrequencyWarning(true)))
                                }, " Save Task and Add Another ")
                              ], 64 /* STABLE_FRAGMENT */)),
                          _createElementVNode("span", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ms-2 btn btn-md btn-outline-secondary",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancel()))
                            }, " Cancel ")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["application-id"])
              ], 8 /* PROPS */, _hoisted_4))
            : (_openBlock(), _createElementBlock("td", {
                key: 1,
                colspan: _ctx.columns,
                class: "p-3"
              }, [
                _createElementVNode("div", null, [
                  _hoisted_54,
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-primary",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.createTask(_ctx.saveType)))
                    }, " Schedule Task "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-outline-secondary ms-2",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeFrequencyWarning()))
                    }, " Cancel ")
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_53))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}